module.exports = __webpack_public_path__ + "img/emoji_14.9612f835.png";